













































































































import {Component, Prop, Vue} from "vue-property-decorator";
import MillisecondDatePicker from "@/shared/components/MillisecondDatePicker/index.vue";
import UploadImage from "@/shared/components/UploadImage/Index.vue";
import {FormModel} from "ant-design-vue";
import InputTimeCustom from "@/shared/components/InputTimeCustom/index.vue";
import InputDateCustom from "@/shared/components/InputDateCustom/index.vue";
import AInputBarCode from "@/shared/components/InputBarCode/index.vue";
import ReportDeliveryExcel from "@/modules/reportdelivery/Form/Excel/index.vue";
import {createReportDeliveryExcel} from "@/modules/reportdelivery/service";
import moment from "moment";
import {FORMAT_DATE_PICKER} from "@/shared/constant";
import {LadingStatus} from "@/enums/status";
import {getChecking} from "@/modules/checking/services";

const form = {
    id: "",
    ladingCode: "",
    receiver: "",
    reportDeliveryDate: moment().format(FORMAT_DATE_PICKER).toString(),
    reportDeliveryTime: "",
    note: "",
    image: "",
    imageUrl: ""
};
const columns = [
    {
        title: 'STT',
        dataIndex: 'stt',
        key: 'stt',
        align: 'center',
        width: 50
    },
    {
        title: 'Mã vận đơn',
        dataIndex: 'ladingCode',
        key: 'ladingCode',
        align: 'center',
        scopedSlots: { customRender: "ladingCode" },
        width: 150
    },
    {
        title: 'Người nhận',
        dataIndex: 'receiver',
        key: 'receiver',
        align: 'center',
        scopedSlots: { customRender: "receiver" },
        width: 150
    },
    {
        title: 'Giờ báo phát',
        dataIndex: 'reportDeliveryTime',
        key: 'reportDeliveryTime',
        align: 'center',
        scopedSlots: { customRender: "reportDeliveryTime" },
        width: 100
    },
    {
        title: 'Ngày báo phát',
        dataIndex: 'reportDeliveryDate',
        key: 'reportDeliveryDate',
        align: 'center',
        scopedSlots: { customRender: "reportDeliveryDate" },
        width: 150
    },
    {
        title: 'Ghi chú',
        dataIndex: 'note',
        key: 'note',
        align: 'center',
        scopedSlots: { customRender: "note" },
        width: 150,
        ellipsis: true
    },
    {
        title: 'Xóa',
        dataIndex: 'ladingCode',
        key: 'action',
        align: 'center',
        scopedSlots: { customRender: "action" },
        width: 50
    }
];
@Component({
    name: "FormReportDelivery",
    components: {
        ReportDeliveryExcel,
        AInputBarCode, InputDateCustom, InputTimeCustom, UploadImage, MillisecondDatePicker}
})
export default class extends Vue {
    @Prop()
    readonly id!: number;
    reportDeliveries = [] as any;
    columns = [...columns];
    isSubmitting = false;
    private form = {...form};
    private rules = {
        id: [{required: false, message: "", trigger: "change"}],
        ladingCode: [{required: true, message: "Nhập mã vận đơn", trigger: "change"}],
        receiver: [{required: true, message: "Nhập tên người nhận", trigger: "change"}],
        reportDeliveryTime: [{required: true, message: "Nhập giờ nhận", trigger: "change"}],
        reportDeliveryDate: [{required: true, message: "Nhập ngày nhận", trigger: "change"}]
    }

    async onSubmit() {
        if (!this.reportDeliveries || !this.reportDeliveries?.length) {
            this.$message.error("Vui lòng nhập  để tạo báo phát");
            return false;
        }
        try {
            this.isSubmitting = true;
            await createReportDeliveryExcel({
                reportDeliveries: this.reportDeliveries
            });
            this.$message.success("Tạo báo phát thành công");
        } catch (e) {
            this.$message.error(e?.response?.data?.message || "Tạo báo phát thất bại");
        } finally {
            this.isSubmitting = false;
        }
    }

  addReportDelivery() {
    (this.$refs.formSite as FormModel).validate(async valid => {
      if (!valid) return;
      if (this.reportDeliveries.some((data: any) => data.ladingCode === this.form.ladingCode)) {
        this.$message.error("Mã vận đơn đã tồn tại");
        return;
      }
      const currentLadingCode = this.form.ladingCode;
      try {
        const {data} = await getChecking(currentLadingCode);
        for (const i in data.datas) {
          if (data.datas[i].billLading.status != LadingStatus.DiPhat){
            this.$notification.error({
              message: "Không đủ điều kiện",
              description: "Mã vật đơn không đủ điều kiện báo phát"
            })
            return;
          }
        }
        this.reportDeliveries.push({...this.form, stt: this.reportDeliveries.length + 1, images: [this.form.image]});
        this.form = { ...form };
        (this.$refs.ladingCode as any).focus();
      } catch (e) {
        this.$message.error(e?.response?.data?.message || "Checking thất bại");
      }
    });
  }

    deleteLading(billLading: any) {
        const index = this.reportDeliveries.findIndex((lading: any) => billLading.ladingCode === lading.ladingCode);
        this.reportDeliveries.splice(index, 1);
    }
}
